// eslint-disable-next-line import/prefer-default-export
export const ERROR_CODES = {
  REQUEST: {
    NOT_ALLOWED: 'NOT_ALLOWED',
    INCORRECT_STATE: 'INCORRECT_STATE',
  },
  ENTITY: {
    ALREADY_EXISTS: 'ENTITY_ALREADY_EXISTS',
    NOT_FOUND: 'ENTITY_NOT_FOUND',
  },
  USER: {
    INVALID_LOGIN: 'INVALID_USERNAME_OR_PASSWORD',
    INVALID_PASSWORD: 'INVALID_PASSWORD',
    INVALID_OTP: 'INVALID_OTP',
    INVALID_RESET_TOKEN: 'INVALID_RESET_TOKEN',
    VERIFICATION_REQUIRED: 'MUST_BE_VERIFIED',
    OLD_NEW_PASSWORD_SAME: 'OLD_NEW_PASSWORD_SAME',
  },
  BOOKING_SLOTS: {
    OVERLAP: 'BOOKING_SLOT_OVERLAPS_EXISTING',
  },
  CONTACT: {
    ALREADY_EXISTS: 'DUPLICATE_PRISONER_NUMBER',
  },
  PAYMENT: {
    STRIPE: 'STRIPE_ERROR',
    TOTAL_VALUE_TOO_LOW: 'TOTAL_VALUE_TOO_LOW',
  },
  RECORDING: {
    NOT_READY: 'NOT_YET_READY',
  },
  UPLOAD: {
    FILE: 'FILE_UPLOAD_ERROR',
  },
  ADDITIONAL_VISITOR: {
    ID_NOT_ALL_PRESENT: 'ID_NOT_ALL_PRESENT',
    ID_TYPE_NOT_VALID: 'ID_TYPE_NOT_VALID',
    NOT_AWAITING_VERIFICATION: 'NOT_AWAITING_VERIFICATION',
    NOT_VERIFIED: 'ADDITIONAL_VISITOR_NOT_VERIFIED',
  },
  VISITOR: {
    ID_NOT_ALL_PRESENT: 'ID_NOT_ALL_PRESENT',
    ID_TYPE_NOT_VALID: 'ID_TYPE_NOT_VALID',
    NOT_AWAITING_VERIFICATION: 'NOT_AWAITING_VERIFICATION',
    NOT_VERIFIED: 'VISITOR_NOT_VERIFIED',
    NO_SAVED_CARD: 'NO_SAVED_CARD',
    BANNED_ON_DATE: 'BANNED_ON_DATE',
  },
  VISIT: {
    NOT_BELONG_TO_PRISON: 'VISIT_NOT_BELONG_TO_PRISON',
    NOT_APPROVED: 'VISIT_NOT_APPROVED',
    VISITOR_NOT_PASSED_PRE_CALL: 'VISITOR_NOT_PASSED_PRE_CALL',
    CANT_CANCEL_HAS_BEGUN: 'CANT_CANCEL_VISIT_HAS_BEGUN',
    REJECT_NOT_CANCEL: 'REJECT_NOT_CANCEL',
    HAS_OUTSTANDING_BALANCE: 'HAS_OUTSTANDING_BALANCE',
    NOT_OF_STATUS: 'NOT_OF_STATUS',
    BOOKING_SLOT_NOT_EXIST: 'BOOKING_SLOT_NOT_EXIST',
    PRISONER_BOOKED_ON_SLOT: 'PRISONER_BOOKED_ON_SLOT',
    VISIT_LIMIT_EXCEEDED: 'VISIT_LIMIT_EXCEEDED',
  },
  VISIT_STOCK: {
    NONE_LEFT: 'NO_STOCK_LEFT',
  },
  CALL: {
    VISITOR_NOT_ON_CALL: 'VISITOR_NOT_ON_CALL',
    PRISONER_NOT_ON_CALL: 'PRISONER_NOT_ON_CALL',
  },
  FACE: {
    NOT_DETECTED: 'NO_FACE_DETECTED',
  },
  PRISON: {
    NOT_ALLOWED_TO_BOOK: 'NOT_ALLOWED_TO_BOOK',
    KIOSK_DISABLED: 'KIOSK_DISABLED',
    NOT_ENOUGH_FUND_TOKENS: 'NOT_ENOUGH_FUND_TOKENS',
    TOO_MANY_KIOSK_ITEMS: 'TOO_MANY_KIOSK_ITEMS',
  },
  KIOSK_ITEMS: {
    NOT_ALL_FOUND: 'NOT_ALL_FOUND',
    DONT_BELONG_TO_PRISON: 'KIOSK_ITEMS_DONT_BELONG_TO_PRISON',
    NOT_AVAILABLE: 'KIOSK_ITEMS_NOT_AVAILABLE',
  },
  WINGS: {
    WING_NOT_PROVIDED: 'WING_NOT_PROVIDED',
    WING_MUST_BE_ENABLED: 'WING_MUST_BE_ENABLED',
    NO_WING_STOCK_LEFT: 'NO_WING_STOCK_LEFT',
    STOCK_EXCEEDS_PRISONS_TERMINAL_COUNT: 'STOCK_EXCEEDS_PRISONS_TERMINAL_COUNT',
  },
};
